import React, { useState } from 'react'
import { apiPut } from '../../API/Api_Url';
import { toast } from 'react-toastify';

function UpdateLabourJobStatusModel({ isOpen, onClose, SelectedReq, GetUserAllPendingLabourJobPost }) {
    const [IsLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState(SelectedReq?.Status || "Pending");

    const onUpdate = async () => {
        try {
            setIsLoading(true);

            if (!status) {
                toast.error("Please select a status");
                return;
            }

            const response = await apiPut(`/api/user/UserUpdateLabourJobRequirementStatus/${SelectedReq?._id}`, {
                status: status,
            });
            toast.success(response?.message || "Status updated successfully");
            onClose();
            GetUserAllPendingLabourJobPost();
        } catch (error) {
            console.error("Error updating LabourJobPost status:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        Update Labour Job Status
                    </h2>
                    <p className="text-gray-600 mb-4">
                        Change the status of this Labour Job Post:
                    </p>

                    {/* Dropdown */}
                    <select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="Pending">Pending</option>
                        <option value="InProgress">In Progress</option>
                        <option value="Completed">Completed</option>
                        <option value="Cancelled">Cancelled</option>
                    </select>

                    <div className="flex justify-end gap-3">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onUpdate}
                            disabled={IsLoading}
                            className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600 transition"
                        >
                            {IsLoading ? "Updating..." : "Update"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateLabourJobStatusModel;
